// ENTITY fr.gestionpial.pial.dto.RemplacementDTO generated by ic2 no-version-available at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';
import { RemplacementEcoleDTO } from './RemplacementEcoleDTO';
import { Aesh } from './Aesh';
import { AbsenceAesh } from './AbsenceAesh';

export class RemplacementDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.RemplacementDTO';

  absence: AbsenceAesh | null = null;
  aeshAbsente: Aesh | null = null;
  ecoles: RemplacementEcoleDTO[] | null = [];
  totalReserveMinutes: number | null = 0;

  constructor(init?:Partial<RemplacementDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.RemplacementDTO'] = RemplacementDTO;

fields['fr.gestionpial.pial.dto.RemplacementDTO']  = {
    absence: 'fr.gestionpial.pial.entities.AbsenceAesh',
    aeshAbsente: 'fr.gestionpial.pial.entities.Aesh',
    ecoles: 'java.util.List<fr.gestionpial.pial.dto.RemplacementEcoleDTO>',
    totalReserveMinutes: 'java.lang.Integer'
};
